module.exports = __webpack_public_path__ + "static/media/plus-grey.d8e0be7d.svg";